import { environment } from '../../environments/environment';

export class GoogleMapLoaderService {
  private static promise: Promise<any>;
  public static load(): Promise<any> {
    const map = {
      URL:
        'https://maps.googleapis.com/maps/api/js?libraries=geometry,places,drawing&key=' +
        environment.google.apiKey +
        '&callback=__onGoogleLoaded',
    };
    // First time 'load' is called?
    if (!this.promise) {
      // Make promise to load
      this.promise = new Promise((resolve) => {
        this.loadScript(map.URL);
        // Set callback for when google maps is loaded.
        (window as any)['__onGoogleLoaded'] = ($event?: any) => {
          resolve('google maps api loaded');
        };
      });
    }

    // Always return promise. When 'load' is called many times, the promise is already resolved.
    return this.promise;
  }
  static loadScript(src: string, callback?: () => void): void {
    let s: HTMLScriptElement;
    let r = false;
    let t: HTMLScriptElement;
    s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    s.onload = (s as any).onreadystatechange = function (this: any) {
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        r = true;
        if (typeof callback === 'function') {
          callback();
        }
      }
    };
    t = document.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(s, t);
  }
}
